"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This component implements https://confluence.oci.oraclecorp.com/display/UX/Health+Status
 */
var React = require("react");
var classNames = require("classnames");
var Aria_1 = require("../../resources/Aria");
var Icon_1 = require("../../resources/Icon");
var status_1 = require("./status");
/**
 * OUI status label component.
 *
 * @oui-component StatusLabel
 */
var StatusLabel = function (_a) {
    var statusType = _a.statusType, showRole = _a.showRole, children = _a.children, testId = _a.testId, rest = __rest(_a, ["statusType", "showRole", "children", "testId"]);
    var colors = status_1.getStyles(statusType);
    // Because the text and icon colors don't match(some times) we need to map them.
    var labelProps = __assign({}, rest, { role: showRole ? Aria_1.Roles.Status : undefined, "data-test-id": testId, className: classNames("oui-display-inline-block", colors.text) });
    return (React.createElement("span", __assign({}, labelProps),
        React.createElement("span", { 
            // Change the component key when the status change forces the component to unmount/mount
            // thus have UIkit re-run its icon code.
            key: statusType.toString(), "data-oui-icon": "icon: " + Icon_1.default.Circle + "; ratio: 0.7", className: classNames("oui-margin-small-right", "oui-center-status-icon", colors.icon), "aria-hidden": "true" }),
        children));
};
StatusLabel.defaultProps = {
    showRole: true
};
/**
 * A status label component.
 */
exports.default = StatusLabel;
//# sourceMappingURL=StatusLabel.js.map